import { Modal, Checkbox, Button, message as Message } from "antd";
import { useState, useEffect } from "react";
import axiosInstance from "../config/axiosInstance";
import { webAPIs } from "../config/webAPIs";

export default function FilterModal({
  visible,
  onClose,
  attributes,
  projectId,
  onFiltered,
  fetchFilesForProject,
  appliedFilters,
  setAppliedFilters,
  lastFilteredFiles,
}) {
  const [filterSelections, setFilterSelections] = useState([]);
  const [previewFiles, setPreviewFiles] = useState([]);

  useEffect(() => {
    console.log(lastFilteredFiles)
    if (visible) {
      setFilterSelections(appliedFilters || []);
      setPreviewFiles(lastFilteredFiles || []); 
    }
  }, [visible, appliedFilters, lastFilteredFiles]);

  const handleLevelChange = (attributeId, levelIds) => {
    setFilterSelections((prev) => [
      ...prev.filter((f) => f.attributeId !== attributeId),
      ...levelIds.map((levelId) => ({ attributeId, levelId })),
    ]);
  };

  const handleApplyFilter = async () => {
    if (!projectId) {
      Message.error("Project not found.");
      return;
    }
    try {
      let data;
      if (filterSelections.length === 0) {
        data = await fetchFilesForProject(projectId);
      } else {
        const res = await axiosInstance.post(webAPIs.filterDocuments, {
          projectId,
          filters: filterSelections,
        });
        data = res.data;
      }
      setPreviewFiles(data);
      onFiltered(data, filterSelections);
    } catch {
      Message.error("Filtering failed.");
    }
  };

  const handleClearFilter = async () => {
    const allFiles = await fetchFilesForProject(projectId);
    setFilterSelections([]);
    setAppliedFilters([]);
    onFiltered(allFiles, []);
    onClose();
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="clear" onClick={handleClearFilter}>
          Clear Filter & Show All
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleApplyFilter}
          className="bg-[#1677ff]"
        >
          Apply Filter
        </Button>,
      ]}
      title="Filter Documents by Attribute Levels"
      width={700}
      destroyOnClose // Good to keep this, it unmounts the modal and resets state on close
    >
      <div style={{ display: "flex", gap: 24 }}>
        <div style={{ flex: 1, overflowY: 'auto', maxHeight: '60vh' }}>
          {Array.isArray(attributes) && attributes.length > 0 ? (
            attributes.map((attr) => (
              <div key={attr.id} style={{ marginBottom: 16 }}>
                <div className="mb-1 font-medium">{attr.name}</div>
                <Checkbox.Group
                  value={filterSelections
                    .filter((f) => f.attributeId === attr.id)
                    .map((f) => f.levelId)}
                  onChange={(levelIds) => handleLevelChange(attr.id, levelIds)}
                  style={{ display: "flex", flexDirection: "column", gap: 4 }}
                >
                  {Array.isArray(attr.DocumentAttributeLevels) &&
                    attr.DocumentAttributeLevels.map((level) => (
                      <Checkbox value={level.id} key={level.id}>
                        {level.value}
                      </Checkbox>
                    ))}
                </Checkbox.Group>
              </div>
            ))
          ) : (
            <div>No attributes found for this project.</div>
          )}
        </div>
        <div style={{ flex: 1, overflowY: 'auto', maxHeight: '60vh' }}>
          <div className="mb-2 font-medium">Filtered Files Preview ({previewFiles.length})</div>
          <ul className="list-disc list-inside">
            {Array.isArray(previewFiles) && previewFiles.map((f) => (
              <li key={f.id} className="truncate">{f.originalName}</li>
            ))}
          </ul>
        </div>
      </div>
    </Modal>
  );
}